import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";

export default function Favorites() {

    const [favorites, setFavorites] = useState('');

    useEffect(() => {
        var currentFavorites = localStorage.getItem('favorites');
        setFavorites(currentFavorites);
    }, [])

    return(
        <>
            <Navbar fixed />
            <main>
                <div className="relative pt-12 pb-32 flex content-center items-center justify-center min-h-screen-75">
                    <div style={{marginTop:'150px', paddingLeft:'10%', paddingRight:'10%'}} className="absolute top-0 w-full h-full bg-center bg-blueGray-200">
                    <div className="pr-12">
                        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                        <div className="rounded-t mb-0 px-4 py-3 border-0">
                            <div className="flex flex-wrap items-center">
                                <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                                <h3 className="font-semibold text-base text-blueGray-700">
                                    Lista de Nombres Favoritos
                                </h3>
                                <p className="text-base text-blueGray-400">
                                    Nota: Los datos mostrados en la tabla se guardan en el localStorage
                                </p>
                                </div>
                            </div>
                            </div>
                            <div className="block w-full overflow-x-auto">
                            <table className="items-center w-full bg-transparent border-collapse">
                                <thead>
                                <tr>
                                    <th className="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                                    Nombre
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    {favorites.split(',').map((item, index) => {
                                    return(
                                    <tr key={index}>
                                        <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                                            {item}
                                        </th>
                                    </tr>)
                                    })}
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </main>
        </>
    )
}
